import * as React from 'react';

import {PeepRecurringTasks} from './peep-recurring-tasks';
import {PeepRelatedLeads} from './peep-related-leads';

import styles from './peep-top-right-info.module.css';

type Props = {
    peepApiId: string;
    model: any;
};

export class PeepTopRightInfo extends React.Component<Props> {
    render() {
        return (
            <div className={styles['peep-top-right-info']}>
                <PeepRelatedLeads id={this.props.peepApiId} />
                <PeepRecurringTasks peepApiId={this.props.peepApiId} model={this.props.model} />
            </div>
        );
    }
}
